import { Flex, Text, useDisclosure } from '@chakra-ui/react';

import { NewCreditModalContainer } from '~/components/common/credits/NewCreditModalContainer';
import { Button } from '~/components/ui/button';
import { useI18nLn } from '~/hooks/store';
import { GmoCredit } from '~/types/resources/gmo_credit';
import { CenteringLoadingCircle } from '../CenteringLoadingCircle';
import { UserCreditSelectList } from './UserCreditSelectList';

type Props = {
  setCardSeq: (card_seq: string) => void;
  credits: GmoCredit[];
  loading: boolean;
  mutate: () => void;
};

export const UserCreditSelectListContainer: React.FC<Props> = (
  props: Props
) => {
  const { t } = useI18nLn();
  const new_credit_disclosure = useDisclosure();

  if (props.loading) return <CenteringLoadingCircle />;

  const creditList = Array.isArray(props.credits) ? props.credits : [];

  return (
    <Flex flexDir="column" w="full">
      <UserCreditSelectList
        credits={props.credits}
        setCardSeq={props.setCardSeq}
        mutate={props.mutate}
      />

      {creditList.length < 5 ? (
        <>
          <Flex justifyContent="center" w="full">
            <Button
              h="32px"
              w="240px"
              borderRadius="8px"
              borderColor="primary"
              fontSize="14px"
              fontWeight="bold"
              colorPalette="main"
              variant="outline"
              onClick={new_credit_disclosure.onOpen}
            >
              {t('pages.buy.payments.credit.register_card')}
            </Button>
          </Flex>
          <NewCreditModalContainer
            disclosure={new_credit_disclosure}
            setCardSeq={props.setCardSeq}
            mutate={props.mutate}
          />
        </>
      ) : (
        <Text px="16px" fontSize="13px">
          {t('pages.buy.payments.credit.quantity_full')}
        </Text>
      )}
    </Flex>
  );
};
